var ValueJS = ValueJS || {};

ValueJS.AnimateCSS = function() {

    var _initialized = false;
    var _selector = '[data-anim-fx]:not(.animate__animated)';
    var _defaultDelay = 200;

    var _observer;

    var _init = function() {
        if (!_initialized) {
            // initialize observer
            _observer = new IntersectionObserver(_handleIntersect, {
                root: null,
                rootMargin: '0px'
            });
            _initialized = true;
        }
        $(_selector).each(function() {
            let el = $(this);
            if (el.parents('.swiper-slide').length === 0 ) {
                _observer.observe(el[0]);
            }
        });
    }

    var _handleIntersect = function(entries, observer) {
        entries.forEach( function(entry) {
            if (entry.isIntersecting) {
                _animate($(entry.target));
                _observer.unobserve(entry.target);
            }
        });
    }

    var _animate = function(el) {
        let fx = el.data('anim-fx');
        let delay = (Number(el.data('anim-delay')) || 0) + _defaultDelay;
        setTimeout(function() {
            el.addClass('animate__animated animate__' + fx);
        }, delay);
    }

    var _reset = function(el) {
        if (el.hasClass('animate__animated')) {
            el.removeClass('animate__animated animate__' + el.data('anim-fx'));
            let delay = ((Number(el.data('anim-delay')) || 0) + _defaultDelay) + 1;
            setTimeout(() => {_observer.observe(el[0]);}, delay);
        }
    }

    var _domUpdate = function() {
        $(_selector).each(function() {
            let el = $(this);
            if (el.parents('.swiper-slide').length === 0 ) {
                _observer.unobserve(el[0]);
                _reset(el);
            }
        });
        _init();
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        animate: function(el) {return _animate(el);},
        reset: function(el) {return _reset(el);},
        domUpdate : function() {return _domUpdate();}
    };

}();

$(function() {
    ValueJS.AnimateCSS.init();
});
